import React from "react";
import { Info } from "lucide-react";
import { PARTIAL_VIEW_TEXT, DEMO_TITLE, DEMO_TEXT } from "./fusionApi";

/** FUSION.md §6: per user, never per chain, and never with a count of what is hidden. */
export const PartialViewBanner = ({ show }) =>
  show ? (
    <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 mb-3 text-sm text-amber-800" role="status">
      <span className="font-semibold whitespace-nowrap">Partial view</span>
      <span>{PARTIAL_VIEW_TEXT}</span>
    </div>
  ) : null;

/** FUSION.md §1: org-level, from the summary's DemonstrationData; FusionPanel shows it above every view. */
export const DemonstrationBanner = ({ show }) =>
  show ? (
    <div className="flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 mb-3 text-sm text-sky-800" role="status">
      <span className="font-semibold whitespace-nowrap">{DEMO_TITLE}</span>
      <span>{DEMO_TEXT}</span>
    </div>
  ) : null;

export const HelpDot = ({ text }) => (
  <span className="inline-flex items-center cursor-help text-content-muted" title={text} aria-label={text}>
    <Info className="h-3.5 w-3.5" />
  </span>
);
